import { css } from '@emotion/react';
import { PaymentPlanModel } from '@frontend/api-payment-plans';
import { Chips } from '@frontend/chips';
import { useMultiLocationUtils } from '@frontend/payments-hooks';
import { Text } from '@frontend/design-system';
import { PaymentPlanStatusChip } from '../../PaymentPlanStatusChip';

export const RowHeader = ({ paymentPlan }: { paymentPlan: PaymentPlanModel }) => {
  const { getLocationName } = useMultiLocationUtils();

  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
      `}
    >
      <div
        css={css`
          flex-grow: grow;
        `}
      >
        <Text>
          {paymentPlan.person.firstName} {paymentPlan.person.lastName}
        </Text>
        <div>
          <Chips.LocationChip
            css={css`
              max-width: none;
            `}
          >
            {getLocationName(paymentPlan.locationId)}
          </Chips.LocationChip>
        </div>
      </div>
      <div
        css={css`
          align-self: center;
        `}
      >
        <PaymentPlanStatusChip paymentPlanStatus={paymentPlan?.status} statusReason={paymentPlan?.statusReason} />
      </div>
    </div>
  );
};
